import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/translations.actions';
import { AumicoNotesService } from '../services/notes.service';

@Injectable()
export class TranslationsEffects {
    constructor(private actions$: Actions, private service: AumicoNotesService) {}

    getTranslations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getTranslations),
            mergeMap((action) => {
                return this.service.getTranslations(action.locales, action.untranslatedOnly).pipe(
                    map((response) => {
                        return fromActions.onGetTranslationsSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(fromActions.onGetTranslationsFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    updateTranslations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.updateTranslations),
            mergeMap((action) => {
                const observable$ = this.service.updateTranslations(action.payload);
                return observable$.pipe(
                    map(() => {
                        return fromActions.onUpdateTranslationsSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.onUpdateTranslationsFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );
}
